import React, { useState, useEffect, useRef } from "react";
import {
  AvatarContainerMini,
  ContainerBodyMini,
  ContainerEyes,
  ContainerMouthMini,
  ContainerMouthMiniOpen,
  AvatarContainerDiv,
  TextBox,
  Panel,
  CancelButton,
} from "./talkingPageyStyled";
import { useCSV } from "../../../customHooks";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import Body from "../../../assets/SVGs/Body/body";
import Eyes1 from "../../../assets/SVGs/Eyes/eyes1";
import Mouth1 from "../../../assets/SVGs/Mouth/mouth1";
import { talkingPageySubject } from "../../../subjects/subjects";

export default function TalkingPagey() {
  const [displayText, setDisplayText] = useState("");
  const [keepMouthOpen, setKeepMouthOpen] = useState(true);
  const animationFrameRef = useRef<any>(null);
  
  useEffect(() => {
    talkingPageySubject.subscribe((text: any) => {
      setDisplayText("");
      let result = "";
      let index = 0;

      const addLetter = () => {
        if (index < text.length) {
          result = result + text[index];
          setDisplayText(result);
          index++;
          animationFrameRef.current = setTimeout(() => {
            addLetter();
          }, 50);
        }
        if (index === text.length) {
          setKeepMouthOpen(true);
        }
      };

      const startAnimation = () => {
        setDisplayText(" ");
        setTimeout(() => {
          setKeepMouthOpen(false);
          addLetter();
        }, 50);
      };

      startAnimation();

      return () => {
        if (animationFrameRef.current) {
          clearTimeout(animationFrameRef.current);
        }
      };
    });
  }, []);

  const handleCancelButtonClick = () => {
    setDisplayText("");
    if (animationFrameRef.current) {
      clearTimeout(animationFrameRef.current);
    }
  };

  return (
    <>
      {displayText && (
        <Panel>
          <CancelButton onClick={() => handleCancelButtonClick()}>
            <FontAwesomeIcon
              style={{
                cursor: "pointer",
                color: "red",
                fontSize: "14px",
                position: "absolute",
                top: "5px",
                right: "6px",
              }}
              icon={faTimesCircle}
            />
          </CancelButton>
          <AvatarContainerDiv>
            <AvatarContainerMini>
              <TextBox>{displayText}</TextBox>
              <ContainerBodyMini>
                <Body
                  className=""
                  scale="0.6"
                  fillBody="#5aa04b"
                  fillTop={"#5aa04b"}
                  fillLines="#000000"
                />
              </ContainerBodyMini>
              <ContainerEyes>
                <Eyes1
                  className=""
                  fillEyes="#000000"
                  scale="0.6"
                  fillEyebrows="#000000"
                />
              </ContainerEyes>
              {keepMouthOpen ? (
                <ContainerMouthMiniOpen>
                  <Mouth1
                    scale="0.6"
                    mouthColorTop="#a90000"
                    mouthColorBottom="#ff0000"
                    className="normalMouthClass"
                  />
                </ContainerMouthMiniOpen>
              ) : (
                <ContainerMouthMini>
                  <Mouth1
                    scale="0.6"
                    mouthColorTop="#a90000"
                    mouthColorBottom="#ff0000"
                    className="normalMouthClass"
                  />
                </ContainerMouthMini>
              )}
            </AvatarContainerMini>
          </AvatarContainerDiv>
        </Panel>
      )}
    </>
  );
}
